import { ArrowUUpLeft, ChartLineUp, Globe, GearSix, HandCoins, House, Megaphone, Money, Package, Receipt, Sparkle, TShirt, Truck, UsersThree, Wallet, type Icon } from '@phosphor-icons/react';
import type { Permission } from '@brechoflow/contracts';

export interface NavItem {
  label: string;
  to: string;
  icon: Icon;
  /** Aparece se o usuário tiver QUALQUER uma; sem lista, aparece sempre. */
  permission?: Permission[];
  end?: boolean;
}

export interface NavGroup {
  label?: string;
  items: NavItem[];
}

/** Menu lateral na ordem do produto. Itens somem conforme a permissão (recursos de plano mostram o convite de upgrade na tela). */
export const NAV: NavGroup[] = [
  {
    items: [
      { label: 'Dashboard', to: '/', icon: House, end: true },
      { label: 'Produtos', to: '/produtos', icon: TShirt, permission: ['products.read'] },
      { label: 'Estoque', to: '/estoque', icon: Package, permission: ['inventory.read'] },
      { label: 'Pedidos', to: '/pedidos', icon: Receipt, permission: ['orders.read'] },
      { label: 'Devoluções', to: '/devolucoes', icon: ArrowUUpLeft, permission: ['returns.read'] },
      { label: 'PDV', to: '/pdv', icon: Money, permission: ['pos.operate'] },
      { label: 'Consignação', to: '/consignacao', icon: HandCoins, permission: ['consignments.read'] },
      { label: 'Fornecedores', to: '/fornecedores', icon: Truck, permission: ['suppliers.read'] },
      { label: 'Clientes', to: '/clientes', icon: UsersThree, permission: ['customers.read'] },
      { label: 'Marketing', to: '/marketing', icon: Megaphone, permission: ['marketing.manage'] },
      { label: 'Financeiro', to: '/financeiro', icon: Wallet, permission: ['finance.read'] },
      { label: 'Assistente de IA', to: '/assistente', icon: Sparkle, permission: ['ai.assistant'] },
      { label: 'Relatórios', to: '/relatorios', icon: ChartLineUp, permission: ['reports.read'] },
      { label: 'Loja virtual', to: '/loja-virtual', icon: Globe, permission: ['storefront.edit'] },
      { label: 'Configurações', to: '/configuracoes', icon: GearSix, permission: ['settings.manage', 'members.manage', 'audit.read'] },
    ],
  },
];

export function visibleNav(has: (p: Permission) => boolean): NavGroup[] {
  return NAV.map((g) => ({ ...g, items: g.items.filter((i) => !i.permission || i.permission.some(has)) })).filter((g) => g.items.length > 0);
}
